$(document).ready(function () {
    var firstLoad = true
    window.adBlocks = function () {
        if (!firstLoad) return
        firstLoad = false
        $('.card').each(function (i, v) {
            if (i === 3) {
                $(window.adBlock1).insertBefore(v);
                console.log('insert adblock 1');
            }
            if (i === 6) {
                $(window.adBlock2).insertBefore(v);
                console.log('insert adblock 2');
            }
        })
    }
});
